import Vue from "vue";
import Router from "vue-router";
import VueResource from "vue-resource";
import login from "@/components/login/index";
import register from "@/components/register/index";
import main from "@/components/main/index";
import user from "@/components/user/index";
import role from "@/components/role/index";
import index from "@/components/dashboard/index";
import resource from "@/components/resource/index";
import log from "@/components/log/index";
import generator from "@/components/generator/index";
import dictionary from "@/components/dictionary/index";
import schedule from "@/components/schedule/index";
import department from "@/components/department/index";
import notFound from "@/components/notFound/index";
import matureStudent from "@/components/student/matureStudent";
import courseDefaultSet from "@/components/conmom/courseDefaultSet";
import courseDataStatistic from "@/components/conmom/courseDataStatistic";
import student from "@/components/student/student";
import open from "@/components/student/open";
import studentGroup from "@/components/grouping/grouping";
import account from "@/components/accountDetails/accountDetails";
import agentUserInfo from "@/components/agentUserInfo/agentUserInfo";
import goods from "@/components/goodsInfo/index";
import shareReferrerLog from "@/components/shareReferrerLog/index";
import order from "@/components/orderInfo/index";
import orderReport from "@/components/orderInfo/orderReport";
import operationLog from "@/components/orderInfo/operationLog";
import detials from "@/components/orderInfo/detial";
import addOrders from "@/components/orderInfo/addOrders";
import condition from "@/components/condition/index";
import detial from "@/components/condition/detial";
import flashSale from '@/components/conentSaleCenter/flashSale'
import goodsItem from "@/components/goodsInfo/goodsItem";
import departmentManage from "@/components/departmentManage/index";
import teacher from "@/components/teacher/index";
import teacherSchedule from "@/components/teacher/teacherSchedule";
import classroomSchedule from "@/components/classroom/classroomSchedule";
import classroom from "@/components/classroom/index";
import wrongsubject from "@/components/wrongSubject/index";
import teachingResearch from "@/components/teachingResearch/index";
import addNote from "@/components/teachingResearch/addNote";
import addVideo from "@/components/teachingResearch/addVideo";
import testQuestions from "@/components/teachingResearch/testQuestions";
import PPTPlay from "@/components/teachingResearch/PPTPlay";
import teachingContent from "@/components/teachingContent/index";
import teachingPPTPlay from "@/components/teachingContent/PPTPlay";
import teachingTestQuestions from "@/components/teachingContent/testQuestions";
import teachingPlan from "@/components/teachingPlan/index";
import addTeachingPlan from "@/components/teachingPlan/addTeachingPlan";

import examMode from "@/components/classStudy/examMode";
import learningGeneral from "@/components/classStudy/learningGeneral";
import modeDetail from "@/components/classStudy/modeDetail";
import classManage from "@/components/classManage/index";
import classDetailStudent from "@/components/classManage/student";
import addClass from "@/components/classManage/addClass";
import classDetail from "@/components/classManage/classDetail";
import generateClass from "@/components/classManage/generateClass";
import classSchedule from "@/components/classManage/classSchedule";
import campusManage from "@/components/campusManage/index";
import campusList from "@/components/campusManage/campusList";
import subjectCourseManage from "@/components/classroom/subjectCourseManage";

import addGoodsTiku from "@/components/goods/addGoodsTiku";
import addGoodsTaocan from "@/components/goods/addGoodsTaocan";
import editGoodsTiku from "@/components/goods/editGoodsTiku";
import editGoodsTaocan from "@/components/goods/editGoodsTaocan";
import goodsInfo from "@/components/goods/index";
import addSeriesGoods from "@/components/goods/addSeriesGoods";
import goodsItems from "@/components/goods/goodsItem";
import bindGoodsByBatch from "@/components/goods/bindGoodsByBatch";
import goodsSchedule from "@/components/goods/goodsSchedule";
import goodsNumber from "@/components/goods/goodsNumber";
import goGoodsInfo from "@/components/goods/goGoodsInfo";
import videoCourse from "@/components/videoCourse/index";
import checkVideo from "@/components/videoCourse/checkVideo";
import checkMaterial from "@/components/videoCourse/checkMaterial";
import addVideoInfo from "@/components/videoCourse/addVideo";
import editVideoInfo from "@/components/videoCourse/editVideo";
import appPage from "@/components/appPage/appPage";
import appEdit from "@/components/appPage/appEdit copy 2";
import goodsClaimCode from "@/components/goodsClaimCode/index";
// import appEdit from "@/components/appPage/appEdit";
import discountCoupon from "@/components/discountCoupon/index";
import addCoupon from "@/components/discountCoupon/addCoupon";
import editCoupon from "@/components/discountCoupon/editCoupon";

import fullTruthModelTest from "@/components/fullTruthModelTest/index";
import testSystem from "@/components/testSystem/index";
import systemExamResult from "@/components/testSystem/systemExamResult";
import systemStudentDetail from "@/components/testSystem/systemStudentDetail";
import systemExamStudent from "@/components/testSystem/systemExamStudent";
import paperManger from "@/components/testSystem/examMode";
import paperPrint from "@/components/testSystem/campusManger";
import systemExamAchivement from "@/components/testSystem/systemExamAchivement";

import paperRequire from "@/components/testSystem/goExamRequire";
import paperCollectionDetail from "@/components/testSystem/paperCollectionDetail";
import candidPhotograph from "@/components/testSystem/candidPhotograph";

import examStudent from "@/components/fullTruthModelTest/examStudent";
import testPaperManage from "@/components/fullTruthModelTest/testPaperManage";
import testPaperSetting from "@/components/fullTruthModelTest/testPaperSetting";
import testPaperManageDetail from "@/components/fullTruthModelTest/testPaperManageDetail";
import examResult from "@/components/fullTruthModelTest/examResult";

import examPaperResult from "@/components/fullTruthModelTest/examPaperResult";
import fullExamSetting from "@/components/fullTruthModelTest/fullExamSetting";
import examSetting from "@/components/fullTruthModelTest/examSetting";
import examSettingDetails from "@/components/fullTruthModelTest/examSettingDetail";
import examAchievement from "@/components/fullTruthModelTest/examAchievement";
import examination from "@/components/fullTruthModelTest/examination";
import previewExamination from "@/components/fullTruthModelTest/previewExamination";
import historyExercise from "@/components/fullTruthModelTest/historyExercise";

import exam from "@/components/exam/index";
import examView from "@/components/examView/index";
import addQuestion from "@/components/question/addQuestion";
import addCpQuestion from "@/components/question/addCpQuestion";
import agentApp from "@/components/agentApp/index";

import xiaoETongLiveInfo from "@/components/xiaoETongLiveInfo/index";
import liveInfo from "@/components/liveInfo/index";
import liveList from "@/components/liveInfo/liveList";
import noticeList from "@/components/notice/noticeList";
import noticeDetail from "@/components/notice/noticeDetail";
import addLiveInfo from "@/components/liveInfo/addLiveInfo";
import editLiveInfo from "@/components/liveInfo/editLiveInfo";
import liveInfoInformation from "@/components/liveInfo/liveInfoInformation";
import liveRoom from "@/components/liveRoom/index";
import liveData from "@/components/liveRoom/liveData";
import agentLevel from "@/components/agentLevel/index";
import classRoomTeaching from "@/components/classRoomTeaching/index";
import signInGeneral from "@/components/classRoomTeaching/signInGeneral";
import generalSituation from "@/components/classRoomTeaching/generalSituation";
import classOverview from "@/components/classRoomTeaching/classOverview";
import studentOverview from "@/components/classRoomTeaching/studentOverview";
import addHomework from "@/components/classRoomTeaching/addHomework";
import viewRecord from "@/components/liveInfo/viewRecord";

import information from "@/components/information/index";
import refundApproval from "@/components/refundApproval/index";
import agentUserInfoAdmin from "@/components/agentUserInfo/agentUserInfoAdmin";
import goodsAgentPrice from "@/components/goodsAgentPrice/goodsAgentPrice";

import policyManage from "@/components/policyManage/index";

import doWork from "@/components/fullTruthModelTest/doWork";
import getResult from "@/components/fullTruthModelTest/getResult";
import searchExam from "@/components/fullTruthModelTest/searchExam";
import examApprovalContent from "@/components/fullTruthModelTest/examApprovalContent";
//考试系统审批试卷
import systemAuditPaper from "@/components/testSystem/systemAuditPaper";
import agencyGoods from "@/components/agencyGoods/index";
import commodityCenter from "@/components/agencyGoods/commodityCenter";
import openRecord from "@/components/openRecord/index";

import subjectType from "@/components/subject/subjectType";
import subjectManage from "@/components/subject/subjectManage";
import subjectCourse from "@/components/subject/subjectCourse";
import subject from "@/components/subject/index";

import materialCenter from "@/components/materialCenter/index";
// import currencySetting from '@/components/setting/currencySetting'
// import paySetting from '@/components/setting/paySetting'
// import agentIntroduction from '@/components/setting/agentIntroduction'
// import privacyAgreement from '@/components/setting/privacyAgreement'
// import customerService from '@/components/setting/customerService'
import setting from "@/components/setting/index";

import commodityClassificationManagement from '@/components/CommodityClassificationManagement/index'
import goodsClassifyManage from '@/components/CommodityClassificationManagement/goodsClassifyManage'

import schoolPage from "@/components/schoolPage/index";
import pcSetting from "@/components/schoolPage/pcSetting";
import companySetting from "@/components/schoolPage/companySetting";
import menuSetting from "@/components/schoolPage/menuSetting";
import miniApp from "@/components/miniApp/index";
import registerForH5 from "@/components/h5/register";
import designPage from "@/components/designPage/index.vue";
import design from "@/components/designPage/design.vue";
import sendNews from "@/components/newsCenter/sendNews";
import newsList from "@/components/newsCenter/newsList";
import newsDetail from "@/components/newsCenter/newsDetail";
import onlineSchool from "@/components/onlineSchool/index";
import advertising from "@/components/advertising/index";
import freeCourses from "@/components/freeCourses/index";
import registerGuide from "@/components/registerGuide/index";
import registerKnowlegePoint from "@/components/registerGuide/registerKnowlegePoint";
import addGuide from "@/components/addGuide/index";
import routerK from "./routerK";
import cardSetting from '@/components/cardSetting/index'

import integral from '@/components/integral/index'
import integralRule from '@/components/integralRule/index'
import project from '@/components/project/index'
import projectUserList from '@/components/project/userList'
import addProject from '@/components/project/add'
import editProject from '@/components/project/edit'
import grade from '@/components/grade/index'
import projectPhase from '@/components/projectPhase/index'
import projectPhaseItem from '@/components/projectPhaseItem/index'
import certificate from '@/components/certificate/index'
import addCertificate from '@/components/certificate/addCertificate'
import editCertificate from '@/components/certificate/editCertificate'
import userCertificate from '@/components/userCertificate/index'
import userProject from '@/components/userProject/index'

Vue.use(Router);
Vue.use(VueResource);
// const originalPush = Router.prototype.push  ExaminationGuide
// Router.prototype.push = function push(location) {
// return originalPush.call(this, location).catch(err => err)
// }
const router = new Router({
  mode: "history",
  routes: [{
    path: "/",
    name: "login",
    component: login
  },
    {
      path: "/register",
      name: "register",
      component: register
    },

    {
      meta: {
        auth: false
      },
      path: "/main",
      name: "main",
      component: main,
      redirect: "/index",
      children: [
        ...routerK, // 防止冲突，路由另起
        {
          path: "/index",
          name: "首页",
          component: index
        },
        {
          meta: {
            auth: true
          },
          path: "/goodsInfo",
          name: "商品管理",
          component: goodsInfo
        },
        {
          meta: {
            auth: false
          },
          path: "/shareReferrerLog",
          name: "分享推荐日志",
          component: shareReferrerLog
        },
        {
          meta: {
            auth: true
          },
          path: "/subjectCourseManage",
          name: "科目课程",
          component: subjectCourseManage
        },
        {
          meta: {
            auth: true
          },
          path: "/subject",
          name: "科目课程管理",
          component: subject
        },
        {
          meta: {
            auth: true
          },
          path: "/classRoomTeaching",
          name: "课堂教学",
          component: classRoomTeaching
        },
        {
          meta: {
            auth: false
          },
          path: "/signInGeneral",
          name: "签到概况",
          component: signInGeneral
        },
        {
          meta: {
            auth: false
          },
          path: "/generalSituation",
          name: "做题概况",
          component: generalSituation
        },

        {
          meta: {
            auth: true
          },
          path: "/matureStudent",
          name: "成考学员",
          component: matureStudent
        },
        {
          meta: {
            auth: false
          },
          path: "/teachingPlan",
          name: "教学计划",
          component: teachingPlan
        },
        {
          meta: {
            auth: false
          },
          path: "/testSystem",
          name: "考试系统",
          component: testSystem
        },
        {
          meta: {
            auth: false
          },
          path: "/addHomework",
          name: "课堂教学",
          component: addHomework
        },
        {
          meta: {
            auth: false
          },
          path: "/classOverview",
          name: "班级概况",
          component: classOverview
        },
        {
          meta: {
            auth: false
          },
          path: "/goodsClassifyManage",
          name: "分类管理",
          component: goodsClassifyManage
        },
        {
          meta: {
            auth: false
          },
          path: "/goodsExhibit",
          name: "商品展示",
          component: commodityClassificationManagement
        },
        {
          meta: {
            auth: false
          },
          path: "/studentOverview",
          name: "学员概况",
          component: studentOverview
        },
        {
          meta: {
            auth: false
          },
          path: "/courseDefaultSet",
          name: "通用统计",
          component: courseDefaultSet
        },
        {
          meta: {
            auth: false
          },
          path: "/courseDataStatistic",
          name: "统计详情",
          component: courseDataStatistic
        },
        {
          meta: {
            auth: true
          },
          path: "/agentUserInfoAdmin",
          name: "人员管理",
          component: agentUserInfoAdmin
        },
        {
          meta: {
            auth: true
          },
          path: "/goodsAgentPrice",
          name: "代理折扣",
          component: goodsAgentPrice
        },
        {
          meta: {
            auth: true
          },
          path: "/agentSubjectCourse",
          name: "机构app管理",
          component: agentApp
        },
        {
          meta: {
            auth: true
          },
          path: "/agentLevel",
          name: "代理等级",
          component: agentLevel
        },
        {
          meta: {
            auth: false
          },
          path: "/goGoodsInfo",
          name: "商品详情",
          component: goGoodsInfo
        },
        {
          meta: {
            auth: false
          },
          path: "/addGoodsTiku",
          name: "添加题库商品",
          component: addGoodsTiku
        },
        {
          meta: {
            auth: false
          },
          path: "/goodsSchedule",
          name: "排班",
          component: goodsSchedule
        },
        {
          meta: {
            auth: false
          },
          path: "/appPage",
          name: "APP首页",
          component: appPage
        },
        {
          meta: {
            auth: false
          },
          path: "/discountCoupon",
          name: "优惠券管理",
          component: discountCoupon
        },
        {
          meta: {
            auth: false
          },
          path: "/flashSale",
          name: "营销中心",
          component: flashSale
        },
        {
          meta: {
            auth: false
          },
          path: "/addCoupon",
          name: "添加优惠券",
          component: addCoupon
        },
        {
          meta: {
            auth: false
          },
          path: "/editCoupon",
          name: "编辑优惠券",
          component: editCoupon
        },
        {
          meta: {
            auth: false
          },
          path: "/appEdit",
          name: "APP编辑",
          component: appEdit
        },
        {
          meta: {
            auth: false
          },
          path: "/addGoodsTaocan",
          name: "添加套餐商品",
          component: addGoodsTaocan
        },
        {
          meta: {
            auth: false
          },
          path: "/editGoodsTaocan",
          name: "修改套餐商品",
          component: editGoodsTaocan
        },
        {
          meta: {
            auth: false
          },
          path: "/editGoodsTiku",
          name: "修改题库商品",
          component: editGoodsTiku
        },
        {
          meta: {
            auth: false
          },
          path: "/addSeriesGoods",
          name: "系列课",
          component: addSeriesGoods
        },

        {
          meta: {
            auth: false
          },
          path: "/goodsClaimCode",
          name: "兑换码管理",
          component: goodsClaimCode
        },
        {
          meta: {
            auth: false
          },
          path: "/goodsItems",
          name: "内容管理",
          component: goodsItems
        },
        {
          meta: {
            auth: false
          },
          path: "/bindGoodsByBatch",
          name: "内容管理",
          component: bindGoodsByBatch
        },
        {
          meta: {
            auth: false
          },
          path: "/goodsNumber",
          name: "查看销量",
          component: goodsNumber
        },
        {
          meta: {
            auth: false
          },
          path: "/user",
          name: "用户管理",
          component: user
        },
        {
          meta: {
            auth: false
          },
          path: "/condition",
          name: "做题情况",
          component: condition
        },
        {
          meta: {
            auth: false
          },
          path: "/goods",
          name: "课程管理",
          component: goods
        },
        {
          meta: {
            auth: false
          },
          path: "/detial",
          name: "做题记录",
          component: detial
        },
        {
          meta: {
            auth: false
          },
          path: "/order",
          name: "订单信息",
          component: order
        },
        {
          meta: {
            auth: false
          },
          path: "/orderReport",
          name: "订单报表",
          component: orderReport
        },
        {
          meta: {
            auth: false
          },
          path: "/operationLog",
          name: "操作记录",
          component: operationLog
        },
        {
          meta: {
            auth: false
          },
          path: "/videoCours",
          name: "录播课程",
          component: videoCourse
        },
        {
          meta: {
            auth: false
          },
          path: "/designPage",
          name: "总模板",
          component: designPage
        },
        {
          meta: {
            auth: false
          },
          path: "/checkVideo",
          name: "查看内容",
          component: checkVideo
        },
        {
          meta: {
            auth: false
          },
          path: "/checkMaterial",
          name: "查看内容",
          component: checkMaterial
        },
        {
          meta: {
            auth: false
          },
          path: "/addVideoInfo",
          name: "添加录播视频",
          component: addVideoInfo
        },
        {
          meta: {
            auth: false
          },
          path: "/editVideoInfo",
          name: "编辑录播视频",
          component: editVideoInfo
        },
        {
          meta: {
            auth: false
          },
          path: "/detials",
          name: "订单详情",
          component: detials
        },
        {
          meta: {
            auth: false
          },
          path: "/addOrders",
          name: "增加商品",
          component: addOrders
        },
        {
          meta: {
            auth: false
          },
          path: "/goodsItem",
          name: "内容管理",
          component: goodsItem
        },
        {
          meta: {
            auth: false
          },
          path: "/role",
          name: "角色管理",
          component: role
        },
        {
          meta: {
            auth: false
          },
          path: "/departmentManage",
          name: "部门管理",
          component: departmentManage
        },
        {
          meta: {
            auth: false
          },
          path: "/resource",
          name: "资源管理",
          component: resource
        },
        {
          meta: {
            auth: false
          },
          path: "/agentUserInfo",
          name: "代理管理",
          component: agentUserInfo
        },
        {
          meta: {
            auth: false
          },
          path: "/log",
          name: "日志列表",
          component: log
        },
        {
          meta: {
            auth: false
          },
          path: "/generator",
          name: "代码生成v2",
          component: generator
        },
        {
          meta: {
            auth: true
          },
          path: "/dictionary",
          name: "参数字典",
          component: dictionary
        },
        {
          meta: {
            auth: false
          },
          path: "/schedule",
          name: "学员分组",
          component: schedule
        },
        {
          meta: {
            auth: false
          },
          path: "/student",
          name: "学员管理",
          component: student
        },
        {
          meta: {
            auth: false
          },
          path: "/studentGoodsContent",
          name: "学员分析",
          component: () => import("@/components/student/studentGoodsContent")
        },
        {
          meta: {
            auth: false
          },
          path: "/classManage",
          name: "班级管理",
          component: classManage
        },
        {
          meta: {
            auth: false
          },
          path: "/teachingResearch",
          name: "教学内容",
          component: teachingResearch
        },
        {
          meta: {
            auth: false
          },
          path: "/sendNews",
          name: "消息发布",
          component: sendNews
        },
        {
          meta: {
            auth: false
          },
          path: "/newsList",
          name: "消息列表",
          component: newsList
        },
        {
          meta: {
            auth: false
          },
          path: "/newsDetail",
          name: "消息详情",
          component: newsDetail
        },
        {
          meta: {
            auth: false
          },
          path: "/teachingPPTPlay",
          name: "教学内容",
          component: teachingPPTPlay
        },
        {
          meta: {
            auth: false
          },
          path: "/teacher",
          name: "师资管理",
          component: teacher
        },
        {
          meta: {
            auth: false
          },
          path: "/teacherSchedule",
          name: "老师排课情况",
          component: teacherSchedule
        },
        {
          meta: {
            auth: false
          },
          path: "/classroomSchedule",
          name: "班级排课情况",
          component: classroomSchedule
        },
        {
          meta: {
            auth: false
          },
          path: "/classroom",
          name: "校区教室",
          component: classroom
        },
        {
          meta: {
            auth: false
          },
          path: "/successfulCandidates",
          name: "成考学员",
          component: () => import("@/components/student/successfulCandidates")
        },
        {
          meta: {
            auth: false
          },
          path: "/auditCenter",
          name: "入职审批",
          component: () => import("@/components/student/auditCenter")
        },
        {
          meta: {
            auth: false
          },
          path: "/materialCenter",
          name: "素材中心",
          component: materialCenter
        },
        {
          meta: {
            auth: false
          },
          path: "/pcIndexV3",
          name: "pc首页",
          component: () => import("@/components/pcV3")
        },
        {
          meta: {
            auth: false
          },
          path: "/setting",
          name: "通用设置",
          component: setting
        },

        {
          meta: {
            auth: false
          },
          path: "/schoolPage",
          name: "pc网校配置",
          component: schoolPage
        },
        {
          meta: {
            auth: false
          },
          path: "/pcSetting",
          name: "pc网校配置",
          component: pcSetting
        },
        {
          meta: {
            auth: false
          },
          path: "/companySetting",
          name: "pc网校公司配置",
          component: companySetting
        },
        {
          meta: {
            auth: false
          },
          path: "/menuSetting",
          name: "pc网校菜单配置",
          component: menuSetting
        },
        {
          meta: {
            auth: false
          },
          path: "/miniApp",
          name: "小程序",
          component: miniApp
        },
        {
          meta: {
            auth: false
          },
          path: "/cardSetting",
          name: "名片设置",
          component: cardSetting
        },
        {
          meta: {
            auth: false
          },
          path: "/account",
          name: "账户明细",
          component: account
        },
        {
          meta: {
            auth: false
          },
          path: "/studentGroup",
          name: "学员分组",
          component: studentGroup
        },
        {
          meta: {
            auth: false
          },
          path: "/open",
          name: "批量开课",
          component: open
        },
        {
          path: "/examSetting",
          name: "考试设置",
          component: examSetting
        },
        {
          path: "/systemExamStudent",
          name: "考试学员",
          component: systemExamStudent
        },
        {
          meta: {
            auth: false
          },
          path: "/information",
          name: "资讯管理",
          component: information
        },
        {
          meta: {
            auth: false
          },
          path: "/policyManage",
          name: "政策管理",
          component: policyManage
        },
        {
          meta: {
            auth: false
          },
          path: "/refundApproval",
          name: "退单审批",
          component: refundApproval
        },
        {
          meta: {
            auth: false
          },
          path: "/doWork",
          name: "资讯管理",
          component: doWork
        },
        {
          meta: {
            auth: false
          },
          path: "/getResult",
          name: "模考",
          component: getResult
        },
        {
          meta: {
            auth: false
          },
          path: "/searchExam",
          name: "成绩查询",
          component: searchExam
        },
        {
          meta: {
            auth: false
          },
          path: "/examApprovalContent",
          name: "试卷审批",
          component: examApprovalContent
        },
        {
          path: "/systemAuditPaper",
          name: "试卷审批",
          component: systemAuditPaper
        },
        {
          path: "/campusManage",
          name: "校区管理",
          component: campusManage
        },
        {
          path: "/campusList",
          name: "部门管理",
          component: campusList
        },
        {
          meta: {
            auth: false
          },
          path: "/department",
          name: "部门管理",
          component: department
        },
        {
          meta: {
            auth: false
          },
          path: "/testPaperManage",
          name: "考卷管理",
          component: testPaperManage
        },
        {
          meta: {
            auth: false
          },
          path: "/testPaperManageDetail",
          name: "考卷管理",
          component: testPaperManageDetail
        },
        {
          meta: {
            auth: false
          },
          path: "/wrongsubject",
          name: "错题排行",
          component: wrongsubject
        },
        {
          meta: {
            auth: false
          },
          path: "/addNote",
          name: "添加讲义",
          component: addNote
        },
        {
          meta: {
            auth: false
          },
          path: "/addVideo",
          name: "添加视频",
          component: addVideo
        },
        {
          meta: {
            auth: false
          },
          path: "/PPTPlay",
          name: "ppt播放",
          component: PPTPlay
        },
        {
          meta: {
            auth: false
          },
          path: "/teachingContent",
          name: "教学上课",
          component: teachingContent
        },
        {
          meta: {
            auth: false
          },
          path: "/addTeachingPlan",
          name: "添加教学计划",
          component: addTeachingPlan
        },
        {
          path: "/examSettingDetails",
          name: "考试设置详情",
          component: examSettingDetails
        },
        {
          path: "/examination",
          name: "考试解析",
          component: examination
        },
        {
          path: "/previewExamination",
          name: "考试预览",
          component: previewExamination
        },
        {
          path: "/historyExercise",
          name: "历史记录",
          component: historyExercise
        },
        {
          path: "/exam",
          name: "试卷管理",
          component: exam
        },
        {
          path: "/examView",
          name: "试卷",
          component: examView
        },
        {
          meta: {
            auth: false
          },
          path: "/addQuestion",
          name: "添加试题",
          component: addQuestion
        },
        {
          meta: {
            auth: false
          },
          path: "/addCpQuestion",
          name: "添加大题",
          component: addCpQuestion
        },
        {
          path: "/examStudent",
          name: "考试学员",
          meta: {
            auth: false
          },
          component: examStudent
        },

        {
          path: "/fullExamSetting",
          name: "考试设置",
          component: fullExamSetting
        },
        {
          meta: {
            auth: false
          },
          path: "/testPaperSetting",
          name: "考试设置",
          component: testPaperSetting
        },
        {
          path: "/fullTruthModelTest",
          name: "全真模考",
          meta: {
            auth: false
          },
          component: fullTruthModelTest
        },
        {
          meta: {
            auth: false
          },
          path: "/xiaoETongLiveInfo",
          name: "小鹅通直播",
          component: xiaoETongLiveInfo
        },
        {
          meta: {
            auth: false
          },
          path: "/liveInfo",
          name: "直播信息",
          component: liveInfo
        },
        {
          meta: {
            auth: false
          },
          path: "/addLiveInfo",
          name: "添加直播",
          component: addLiveInfo
        },
        {
          meta: {
            auth: false
          },
          path: "/editLiveInfo",
          name: "编辑直播",
          component: editLiveInfo
        },
        {
          meta: {
            auth: false
          },
          path: "/liveList",
          name: "直播课程",
          component: liveList
        },
        {
          meta: {
            auth: false
          },
          path: "/noticeList",
          name: "消息列表",
          component: noticeList
        },
        {
          meta: {
            auth: false
          },
          path: "/noticeDetail",
          name: "消息详情",
          component: noticeDetail
        },
        {
          meta: {
            auth: false
          },
          path: "/liveInfoInformation",
          name: "直播数据",
          component: liveInfoInformation
        },
        {
          meta: {
            auth: false
          },
          path: "/liveRoom",
          name: "直播课程",
          component: liveRoom
        },
        {
          meta: {
            auth: false
          },
          path: "/liveData",
          name: "直播数据统计",
          component: liveData
        },
        {
          meta: {
            auth: false
          },
          path: "/viewRecord",
          name: "观看记录",
          component: viewRecord
        },
        {
          meta: {
            auth: false
          },
          path: "/agencyGoods",
          name: "代理商品",
          component: agencyGoods
        },
        {
          meta: {
            auth: false
          },
          path: "/commodityCenter",
          name: "商品中心",
          component: commodityCenter
        },
        {
          meta: {
            auth: false
          },
          path: "/openRecord",
          name: "开通记录",
          component: openRecord
        },
        {
          meta: {
            auth: false
          },
          path: "/subjectType",
          name: "科目类型",
          component: subjectType
        },
        {
          meta: {
            auth: false
          },
          path: "/subjectManage",
          name: "科目管理",
          component: subjectManage
        },
        {
          meta: {
            auth: false
          },
          path: "/subjectCourse",
          name: "具体课程",
          component: subjectCourse
        },
        {
          meta: {
            auth: false
          },
          path: "/modeDetail",
          name: "模考详情",
          component: modeDetail
        },
        {
          meta: {
            auth: false
          },
          path: "/paperManger",
          name: "证书管理",
          component: paperManger
        },
        {
          meta: {
            auth: false
          },
          path: "/paperPrint",
          name: "证书模板",
          component: paperPrint
        },
        {
          meta: {
            auth: false
          },
          path: "/paperRequire",
          name: "证书要求",
          component: paperRequire
        },
        {
          meta: {
            auth: false
          },
          path: "/paperCollectionDetail",
          name: "证书办理详情",
          component: paperCollectionDetail
        },
        {
          meta: {
            auth: false
          },
          path: "/candidPhotograph",
          name: "考试结果抓拍",
          component: candidPhotograph
        },
        {
          meta: {
            auth: false
          },
          path: "/examResult",
          name: "考试结果",
          component: examResult
        },
        {
          path: "/systemExamResult",
          name: "考试结果",
          component: systemExamResult
        },
        {
          path: "/examPaperResult",
          name: "考试结果",
          component: examPaperResult
        },
        {
          meta: {
            auth: false
          },
          path: "/learningGeneral",
          name: "学习概况",
          component: learningGeneral
        },
        {
          path: "/classDetail",
          meta: {
            auth: false
          },
          name: "班级详情",
          component: classDetail
        },
        {
          path: "/classDetailStudent",
          meta: {
            auth: false
          },
          name: "班级详情",
          component: classDetailStudent
        },
        {
          meta: {
            auth: false
          },
          path: "/generateClass",
          name: "生成排课",
          component: generateClass
        },
        {
          meta: {
            auth: false
          },
          path: "/testQuestions",
          name: "试题库",
          component: testQuestions
        },
        {
          meta: {
            auth: false
          },
          path: "/teachingTestQuestions",
          name: "试题库",
          component: teachingTestQuestions
        },
        {
          meta: {
            auth: false
          },
          path: "/examMode",
          name: "课堂模考",
          component: examMode
        },
        {
          meta: {
            auth: false
          },
          path: "/addClass",
          name: "条件设置",
          component: addClass
        },
        {
          path: "/classSchedule",
          meta: {
            auth: false
          },
          name: "日程",
          component: classSchedule
        },
        {
          path: "/systemStudentDetail",
          name: "个人信息",
          component: systemStudentDetail
        },
        {
          path: "/systemExamAchivement",
          name: "考试成绩",
          component: systemExamAchivement
        },
        {
          path: "/examAchievement",
          name: "考试成绩",
          component: examAchievement
        },
        {
          path: "/notFound",
          name: "notFound",
          component: notFound
        },

        {
          path: "*",
          redirect: "/notFound"
        },
        {
          meta: {
            auth: false
          },
          path: "/onlineSchool",
          name: "网校总模板",
          component: onlineSchool
        },
        {
          meta: {
            auth: false
          },
          path: "/freeCourses",
          name: "广告管理",
          component: advertising
        },
        {
          meta: {
            auth: false
          },
          path: "/freeCourses",
          name: "免费公开课",
          component: freeCourses
        },
        {
          meta: {
            auth: false
          },
          path: "/registerGuide",
          name: "报考指南",
          component: registerGuide
        },
        {
          meta: {
            auth: false
          },
          path: "/registerKnowlegePoint",
          name: "知识点",
          component: registerKnowlegePoint
        },
        {
          meta: {
            auth: false
          },
          path: "/addGuide",
          name: "添加报考指南",
          component: addGuide
        },
        {
          meta: {auth: false},
          path: '/integral',
          name: '积分',
          component: integral
        },
        {
          meta: {auth: false},
          path: '/integralRule',
          name: '积分规则',
          component: integralRule
        },
        {
          meta: {auth: false},
          path: '/project',
          name: '项目',
          component: project
        },
        {
          meta: {auth: false},
          path: '/project/userList',
          name: '项目',
          component: projectUserList
        },
        {
          meta: {auth: false},
          path: '/addProject',
          name: '添加项目',
          component: addProject
        },
        {
          meta: {auth: false},
          path: '/editProject',
          name: '添加项目',
          component: editProject
        },
        {
          meta: {auth: false},
          path: '/grade',
          name: '学分',
          component: grade
        },
        {
          meta: {auth: false},
          path: '/projectPhase',
          name: '项目阶段',
          component: projectPhase
        },
        {
          meta: {auth: false},
          path: '/projectPhaseItem',
          name: '项目阶段内容',
          component: projectPhaseItem
        },
        {
          meta: {auth: false},
          path: '/certificate',
          name: '证书',
          component: certificate
        },
        {
          meta: {auth: false},
          path: '/addCertificate',
          name: '证书',
          component: addCertificate
        },
        {
          meta: {auth: false},
          path: '/editCertificate',
          name: '证书',
          component: editCertificate
        },
        {
          meta: {auth: false},
          path: '/userCertificate',
          name: '用户证书',
          component: userCertificate
        },
        {
          meta: {auth: false},
          path: '/userProject',
          name: '项目用户',
          component: userProject
        },
      ]
    },

    {
      path: "/notFound",
      name: "notFound",
      component: notFound
    },
    {
      path: "/h5Register",
      name: "注册",
      meta: {
        auth: false
      },
      component: registerForH5
    },
    {
      meta: {
        auth: false
      },
      path: "/design",
      name: "编辑总模板",
      component: design
    },
    {
      meta: {
        auth: false
      },
      path: "/margin",
      name: "margin",
      component: () => import("@/components/officialAccount/margin")
    },
    {
      path: "/empowerHfive",
      name: "empowerHfive",
      meta: {
        auth: false
      },
      component: () => import("@/components/officialAccount/empowerHfive"),
      redirect: "/empowerHfive/*",
      children: [{
        path: "*",
        name: "empowerSuccess",
        meta: {
          auth: false
        },
        component: () => import("@/components/officialAccount/empowerSuccess")
      }]
    },
    // {
    //     path: '/empowerHfive/*',
    //     name: '授权成功',
    //     meta: { auth: false },
    //     component: () =>
    //         import ('@/components/officialAccount/empowerHfive')
    // },
    {
      path: "*",
      redirect: "/notFound"
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.auth)) {
    if (localStorage.user != null) {
      let menus = JSON.parse(localStorage.user).resources;
      let flag = 1;
      menus.forEach(item => {
        if (to.path == item.url) {
          flag = 0;
        }
        if (item.resources) {
          item.resources.forEach(items => {
            if (to.path == items.url) {
              flag = 0;
            }
          });
        }
      });
      if (flag === 0) {
        next();
      } else {
        next({
          path: "/notFound"
        });
      }
    } else {
      next({
        path: "/",
        query: {
          redirect: to.fullPath
        }
      });
    }
  } else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js